module.exports = __webpack_public_path__ + "static/media/kn.1ab2d7d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/kn.svg
// module id = 165
// module chunks = 0